import { FillWorkIcon, InputConfig, MapLocationIcon, TItem } from "@cpj-ai/panel-npm-package";
import { AuthAccountProfileEmploymentStatusChoices, useGetJobsLazyQuery } from "@graphql/generated";
import Title from "@modules/JobInterest/components/Title";

export type InterestedJobsFormData = {
  employmentStatus?: AuthAccountProfileEmploymentStatusChoices | null;
  interestedJobs?: TItem[];
};

export const getInputConfig = (): InputConfig[] => {
  return [
    {
      name: "employmentStatusTitle",
      previewSize: 12,
      inputProps: {
        type: "title",
        label: <Title Icon={FillWorkIcon} title="Employment status" />,
      },
    },
    {
      name: "employmentStatus",
      previewSize: 12,
      inputProps: {
        type: "radioGroup",
        label: "Are you currently working somewhere (employed)?",
        labelKey: "label",
        valueKey: "value",
        className: "md:ml-8",
        orientation: "vertical",
        classNames: {
          wrapper: "mb-6",
          label: "font-normal text-base text-black",
        },
        items: [
          { label: "yes, I'm employed", value: AuthAccountProfileEmploymentStatusChoices.EMPLOYED },
          { label: "No, I'm not employed", value: AuthAccountProfileEmploymentStatusChoices.UNEMPLOYED },
        ],
      },
      rules: {
        required: "Please select your employment status",
      },
    },
    {
      name: "interestedJobsTitle",
      previewSize: 12,
      inputProps: {
        type: "title",
        className: "text-base text-black mt-6",
        label: <Title Icon={MapLocationIcon} title="Interested fields of work" />,
      },
    },
    {
      name: "interestedJobs",
      previewSize: 12,
      inputProps: {
        wrapperClassName: "md:pl-8",
        className: "max-w-full sm:w-full lg:w-1/2",
        type: "searcher",
        label: "Interested fields of work:",
        placeholder: "Interested fields of work",
        useLazyQuery: useGetJobsLazyQuery,
        dataPath: "common.jobs",
        labelKey: "title",
        searchKey: "title_Icontains",
        valueKey: "id",
        isMulti: true,
      },
      rules: {
        required: "Please select at least one job",
      },
    },
  ];
};
